module.exports = __webpack_public_path__ + "img/Icon awesome-user-alt.712fada9.svg";